import axios from "axios";

const baseURL =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_DEV_DOMAIN
    : process.env.VUE_APP_DOMAIN;

/**
 * 运营后台登录，与 PptMap.Api POST /api/auth/login 一致。
 * 成功返回 { code: 0, token, message }，token 与 PptSlides:WriteToken 相同。
 */
export function login({ userName, password }) {
  return axios
    .post(`${baseURL}/api/auth/login`, { userName, password })
    .then(r => r.data);
}
